import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Link as MaterialLink, LinkProps as MaterialLinkProps } from '@mui/material';

export const LinkStyled = styled((props: MaterialLinkProps & { to?: string }) => {
  return (
    <MaterialLink component={RouterLink} {...props} />
  );
})(() => '');